import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTRPC } from 'src/utils/trpc';

/**
 * tRPC-only — `createMutationHook` requires a `graphqlDocument` and the
 * scheduler has no GraphQL twin, so this is a plain `useMutation`.
 */
export const useCreateSchedule = () => {
  const trpc = useTRPC();
  const queryClient = useQueryClient();

  return useMutation(
    trpc.frontend.scheduler.createSchedule.mutationOptions({
      onSuccess: async () => {
        await queryClient.invalidateQueries({
          queryKey: trpc.frontend.scheduler.getRegister.queryKey(),
        });
      },
    })
  );
};
